import React from 'react';
import { Field } from 'redux-form';
import { CheckboxWrapper, SubaccountTypeaheadWrapper } from 'src/components';
import { required } from 'src/helpers/validation';
import { ROLES } from 'src/constants';

const SubaccountAssignment = ({ selectedRole, useSubaccountChecked }) => {
  const reportingOrDeveloperRoleSelected =
    selectedRole === ROLES.REPORTING || selectedRole === ROLES.DEVELOPER;
  return (
    <>
      <Field
        id="useSubaccount"
        name="useSubaccount"
        label="Assign to subaccount"
        disabled={!reportingOrDeveloperRoleSelected}
        component={CheckboxWrapper}
        type="checkbox"
      />
      {reportingOrDeveloperRoleSelected && useSubaccountChecked && (
        <Field
          id="subaccount"
          name="subaccount"
          component={SubaccountTypeaheadWrapper}
          validate={required}
          helpText="These users may not be re-assigned to a different subaccount or role after creation."
        />
      )}
    </>
  );
};

export default SubaccountAssignment;
